module.exports = __webpack_public_path__ + "img/foot_code_1.bed03e8c.jpg";